import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n, { resolveHtmlLang } from "./i18n";
import { CurrencyProvider } from "./hooks/useCurrency";
import FloatingChatbot from "./components/feature/FloatingChatbot";
import TopInfoBar from "./components/feature/TopInfoBar";
import Navbar from "./components/feature/Navbar";

function HtmlLangSync() {
  const { i18n: i18nInstance } = useTranslation();
  const lang = i18nInstance.resolvedLanguage || i18nInstance.language || 'en';

  useEffect(() => {
    document.documentElement.lang = resolveHtmlLang(lang);
  }, [lang]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CurrencyProvider>
          <HtmlLangSync />
          <div className="relative min-h-screen flex flex-col">
            {/* 공지사항: 스크롤하면 콘텐츠와 함께 위로 사라짐 */}
            <TopInfoBar />

            {/* 메인 메뉴: 스크롤해도 상단에 고정. transform으로 2px 위로 올려 틈 제거 */}
            <div
              className="sticky top-0 z-[999] w-full pb-[4px] bg-white"
              style={{ transform: 'translateY(-2px)' }}
            >
              <Navbar />
            </div>

            <main className="relative flex-1">
              <AppRoutes />
            </main>

            <FloatingChatbot />
          </div>
        </CurrencyProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;